var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4.14844C6.34315 4.14844 5 5.49158 5 7.14844V11.1484C5 13.9099 7.23858 16.1484 10 16.1484C12.7614 16.1484 15 13.9099 15 11.1484V7.14844C15 6.59615 15.4477 6.14844 16 6.14844C16.5523 6.14844 17 6.59615 17 7.14844V11.1484C17 15.0144 13.866 18.1484 10 18.1484C6.13401 18.1484 3 15.0144 3 11.1484V7.14844C3 4.38701 5.23858 2.14844 8 2.14844C10.7614 2.14844 13 4.38701 13 7.14844V11.1484C13 12.8053 11.6569 14.1484 10 14.1484C8.34315 14.1484 7 12.8053 7 11.1484V7.14844C7 6.59615 7.44772 6.14844 8 6.14844C8.55228 6.14844 9 6.59615 9 7.14844V11.1484C9 11.7007 9.44772 12.1484 10 12.1484C10.5523 12.1484 11 11.7007 11 11.1484V7.14844C11 5.49158 9.65685 4.14844 8 4.14844Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/Paper clip.ef3b1280ed50321b19f0ff625ac577c8.svg";
export { ForwardRef as ReactComponent };